import React, { memo } from 'react';
import classNames from 'classnames';
import './index.scss';

type TPreset =
  | '000000-14-400'
  | '222222-14-400'
  | '262832-12-400'
  | '262832-14-600'
  | '262832-14-700'
  | '262832-16-700'
  | '262832-18-400'
  | '262832-18-700'
  | '262832-20-600'
  | '262832-20-700'
  | '2e95ff-12-400'
  | '2e95ff-12-700'
  | '2e95ff-14-400'
  | '2e95ff-14-500'
  | '376ae7-14-400'
  | '3b3d4b-21-700'
  | '3b3d4b-27-700'
  | '525464-18-700'
  | '838697-12-400'
  | '838697-14-400'
  | '9b9fb0-12-400'
  | '9b9fb0-14-400'
  | 'ebecf1-14-700'
  | 'ff584c-14-400'
  | 'ffffff-12-700';

type TAlign = 'left' | 'center' | 'right';

interface ILabelTextProps extends React.HTMLAttributes<HTMLSpanElement> {
  preset?: TPreset;
  className?: string;
  style?: React.CSSProperties;
  ellipsis?: boolean;
  align?: TAlign;
  lineHeight?: string | number;
}

const LabelText: React.FC<ILabelTextProps> = ({
  preset,
  className,
  style,
  ellipsis,
  align,
  lineHeight,
  children,
  ...rest
}) => {
  const presetClass = preset ? `dbl-label-text__${preset}` : null;
  const cls = classNames(
    'dbl-label-text',
    presetClass,
    ellipsis && 'dbl-label-text--ellipsis',
    align && `dbl-label-text--align-${align}`,
    className,
  );
  const mergedStyle = {
    ...style,
    ...(lineHeight !== undefined
      ? { lineHeight: typeof lineHeight === 'number' ? `${lineHeight}px` : lineHeight }
      : null),
  };

  return (
    <span {...rest} className={cls} style={mergedStyle}>
      {children}
    </span>
  );
};

export default memo(LabelText);
